module.exports = __webpack_public_path__ + "img/mtstudio.949c0ab8.webp";